export enum ROUTES {
  LOGIN = '/login',
  EMAIL_TEMPLATES = '/email-templates',
  EMAILS = '/emails',
  FORMS = '/forms',
  LANDING_PAGES_TEMPLATES = '/landing-pages-templates',
  LANDING_PAGES = '/landing-pages',
  SNIPPETS = '/snippets',
  PROGRAMS = '/programs',
  ORDERS_PROGRAMS = '/orders/programs',
  ORDERS_EMAIL_TEMPLATES = '/orders/email-templates',
  ORDERS_EMAILS = '/orders/emails',
  ORDERS_FORM = '/orders/forms',
  ORDERS_LANDING_PAGE_TEMPLATES = '/orders/landing-page-templates',
  ORDERS_LANDING_PAGES = '/orders/landing-pages',
  ORDERS_SNIPPETS = '/orders/snippets',
  ORDERS_SUCCESS = '/orders/success',
}
